// https://github.com/aws-amplify/amplify-ui/issues/1497#issuecomment-1115188487

import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { type AmplifyUser } from '@aws-amplify/ui'

export interface UserState {
    user: AmplifyUser | null
}

export const useAmplifyStore = create<UserState>()(
    persist(
        devtools(
            (set) => ({
                user: null,
            }),
            { name: 'AmplifyUserStore' },
        ),
        { name: 'amplify-user' },
    ),
)

export const useAmplifyStoreUser = () => useAmplifyStore((state) => state.user)
export const getAmplifyStoreUser = () => useAmplifyStore.getState().user
export const setAmplifyStoreUser = (user: AmplifyUser) => useAmplifyStore.setState({ user })
export const clearAmplifyStore = () => useAmplifyStore.setState({ user: null })
